import { useContext } from "react";
import { DrawerContext } from "./context";

export const useDrawer = () => {
  const ctx = useContext(DrawerContext);
  if (!ctx) {
    throw new Error("Вызов вне контекста");
  }

  return {
    ...ctx,
    isOpen: ctx.drawer?.isOpen ?? false,
  };
};
